export const CompanyRoles = [
  {name: 'Client', slug: 'CLIENT'},
  {name: 'Subcontractor-welding', slug: 'WELDING'},
  {name: 'Subcontractor-inspections', slug: 'INSPECTIONS'},
]



// WEBPACK FOOTER //
// ./src/components/Companies/roles.js